import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const HOUSEHOLDPOPULATIONDENSITYACERS_LAYER_ID =
  'householdPopulationDensityAcresLayer';

const layerConfig = {
  title: 'Household Population Density Acres Layer',
};

function HouseholdPopulationDensityAcresLayer() {
  const dispatch = useDispatch();
  const { householdPopulationDensityAcresLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, householdPopulationDensityAcresLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (householdPopulationDensityAcresLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: HOUSEHOLDPOPULATIONDENSITYACERS_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: householdPopulationDensityAcresLayer.visible,
      opacity: householdPopulationDensityAcresLayer.opacity,
      getFillColor: colorBins({
        attr: 'household_population_density_acres',
        domain: [-0.01, 0, 4.81, 9.56, 13.55, 18.75, 1582.55],
        colors: [
          [178, 34, 34],
          [255, 102, 102],
          [224, 224, 255],
          [180, 210, 255],
          [153, 204, 255],
          [51, 153, 255],
          [51, 102, 255],
          [0, 0, 128],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: HOUSEHOLDPOPULATIONDENSITYACERS_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['geo_level', 'household_population_density_acres'],
            }),
          };
        }
      },
    });
  }
}

export default HouseholdPopulationDensityAcresLayer;
